import React, { FC } from 'react';
import { Helmet } from 'react-helmet';

const TranslationDisabler: FC = () => (
  <Helmet htmlAttributes={{ class: 'notranslate', lang: 'en' }} />
);

export default TranslationDisabler;
